import { useEffect } from 'react';

export type ToastType = 'error' | 'success' | 'info';

interface ToastProps {
  type?: ToastType;
  message: string;
  onClose: () => void;
  duration?: number;
}

const styleMap: Record<ToastType, { wrap: string; icon: string }> = {
  error: { wrap: 'bg-danger-500', icon: 'ri-error-warning-line' },
  success: { wrap: 'bg-success-500', icon: 'ri-checkbox-circle-line' },
  info: { wrap: 'bg-secondary-500', icon: 'ri-information-line' },
};

export default function Toast({ type = 'info', message, onClose, duration = 4000 }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const style = styleMap[type];

  return (
    <div className="pointer-events-none fixed inset-x-0 top-6 z-[100] flex justify-center px-4">
      <div
        className={`pointer-events-auto dc-fade-up flex items-center gap-2 rounded-btn ${style.wrap} px-4 py-3 text-sm font-medium text-white`}
        role="status"
        aria-live="polite"
      >
        <i className={`${style.icon} text-lg leading-none`} aria-hidden="true"></i>
        <span>{message}</span>
        <button
          type="button"
          onClick={onClose}
          className="ms-1 text-white/80 hover:text-white"
          aria-label="إغلاق التنبيه"
        >
          <i className="ri-close-line text-base" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
}